import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck, Phone } from "lucide-react";

const TopBar = () => {
  const { t } = useTranslation();

  const items = [
    t("topbar.rc_pro"),
    t("topbar.cesu"),
    t("topbar.availability"),
  ];

  return (
    <div className="hidden md:flex bg-brand-green text-white text-[10px] font-semibold">
      <div className="container-x flex items-center justify-center gap-6 py-2">
        {items.map((label) => (
          <span key={label} className="flex items-center gap-1.5">
            <ShieldCheck className="h-3 w-3 shrink-0" />
            {label}
          </span>
        ))}
        <a
          href="tel:+33649502801"
          className="flex items-center gap-1.5 text-emerald-100 hover:text-white transition-colors duration-150"
        >
          <Phone className="h-3 w-3 shrink-0" />
          06 49 50 28 01
        </a>
      </div>
    </div>
  );
};

export default TopBar;
